import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconSavings } from '@redteclab/icons'

import { productAccessorGetSellerPromotionFromOffer } from '../../../models/productAccessor/productAccessorGetSellerPromotionFromOffer'
import { ProductSellerPromotionFlag } from '../../ProductSellerPromotionFlag/ProductSellerPromotionFlag'
import { useProductVolumePricingContext } from '../ProductVolumePricingContext'

export const ProductVolumePricingModalNotification: FC = () => {
  const { currentOffer } = useProductVolumePricingContext()

  const sellerPromotion = currentOffer
    ? productAccessorGetSellerPromotionFromOffer(currentOffer)
    : undefined

  return (
    <div className="flex flex-row gap-2 rounded-xl bg-light-primary-low p-4">
      <span className="w-24">
        <div className="flex size-12 shrink-0 items-center justify-center rounded-full bg-light-tertiary font-mono text-2xl font-medium">
          <IconSavings />
        </div>
      </span>
      <div className="flex flex-col">
        {sellerPromotion ? (
          <h3 className="mb-1 text-s font-medium">
            <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
          </h3>
        ) : (
          <h3 className="mb-1 text-s font-medium text-dark-secondary">
            <FormattedMessage id="volumePricing.modal.notification.title" />
          </h3>
        )}
        <span className="text-s font-normal">
          <FormattedMessage id="volumePricing.modal.notification.content" />
        </span>
      </div>
    </div>
  )
}
